import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// === OLYMP PAGES ===
import OlympDashboard from './pages/olymp/OlympDashboard';
import DataCatalog from './pages/olymp/DataCatalog';
import ParameterDetail from './pages/olymp/ParameterDetail';
import Cart from './pages/olymp/Cart';
import Cohorts from './pages/olymp/Cohorts';
import CohortGraphBuilder from './pages/olymp/cohorts/CohortGraphBuilder';
import Requests from './pages/olymp/Requests';

// Shared/Common Pages
import SettingsPage from './pages/SettingsPage';
import HelpSupportPage from './pages/HelpSupportPage';
import LoginPage from './auth/LoginPage';
import { AuthProvider } from './auth/authContext';
import ProtectedRoute from './auth/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Öffentliche Route für Login */}
          <Route path="/login" element={<LoginPage />} />

          {/* ===== OLYMP ROUTES ===== */}
          <Route path="/" element={
            <ProtectedRoute>
              <OlympDashboard />
            </ProtectedRoute>
          } />
          <Route path="/catalog" element={
            <ProtectedRoute>
              <DataCatalog />
            </ProtectedRoute>
          } />
          <Route path="/parameter/:parameterId" element={
            <ProtectedRoute>
              <ParameterDetail />
            </ProtectedRoute>
          } />
          <Route path="/cart" element={
            <ProtectedRoute>
              <Cart />
            </ProtectedRoute>
          } />
          <Route path="/cohorts" element={
            <ProtectedRoute>
              <Cohorts />
            </ProtectedRoute>
          } />
          <Route path="/olymp/cohort-graph" element={
            <ProtectedRoute>
              <CohortGraphBuilder />
            </ProtectedRoute>
          } />
          <Route path="/requests" element={
            <ProtectedRoute>
              <Requests />
            </ProtectedRoute>
          } />

          {/* Common Routes */}
          <Route path="/settings" element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          } />
          <Route path="/help" element={
            <ProtectedRoute>
              <HelpSupportPage />
            </ProtectedRoute>
          } />

          {/* Standardroute zum Login umleiten */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
